module.exports = __webpack_public_path__ + "static/media/plumber.9ffed0ee.png";